import { SYSTEM_FILE_NAMES, SYSTEM_FOLDER_NAMES } from './constants';

export const isSystemFile = (file: File) => {
  const parts = (file.webkitRelativePath || file.name).toLowerCase().split('/');
  const name = parts[parts.length - 1];
  return (
    name.startsWith('.') ||
    SYSTEM_FILE_NAMES.includes(name) ||
    parts.some((part) => SYSTEM_FOLDER_NAMES.includes(part) || part.startsWith('.'))
  );
};

const readEntries = (reader: FileSystemDirectoryReader) =>
  new Promise<FileSystemEntry[]>((resolve, reject) => reader.readEntries(resolve, reject));

const readAllEntries = async (directory: FileSystemDirectoryEntry) => {
  const reader = directory.createReader();
  const entries: FileSystemEntry[] = [];
  for (;;) {
    const batch = await readEntries(reader);
    if (!batch.length) return entries;
    entries.push(...batch);
  }
};

const entryToFile = (entry: FileSystemFileEntry) =>
  new Promise<File>((resolve, reject) => entry.file(resolve, reject));

const collectFiles = async (entry: FileSystemEntry): Promise<File[]> => {
  if (entry.isFile) return [await entryToFile(entry as FileSystemFileEntry)];
  if (!entry.isDirectory) return [];
  if (SYSTEM_FOLDER_NAMES.includes(entry.name.toLowerCase()) || entry.name.startsWith('.'))
    return [];
  const children = await readAllEntries(entry as FileSystemDirectoryEntry);
  const nested = await Promise.all(children.map(collectFiles));
  return nested.flat();
};

export const getDroppedEntries = (dataTransfer: DataTransfer) =>
  Array.from(dataTransfer.items || [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.webkitGetAsEntry?.())
    .filter((entry): entry is FileSystemEntry => Boolean(entry));

export const readDroppedEntries = async (entries: FileSystemEntry[]) =>
  (await Promise.all(entries.map(collectFiles))).flat();
